// AI Generated Test
import { Component, OnInit } from '@angular/core';
import { PageFixRepoService } from '@client/app/services/api/pagefix-repo/page-fix-repo.service';
import { ParamService } from '@monsido/ng2/core/param/param.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { PageFixService } from '@client/app/modules/page-fix/services/page-fix/page-fix.service';
import { PageFixListService } from '@client/app/modules/page-fix/services/list/list.service';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { StateService } from '@uirouter/core';
import { PAGE_FIX_FIXABLE_TYPES } from '@client/app/modules/page-fix/constants/page-fix-fixable-types';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'page-fix-list',
    standalone: false,
    template: `
        <page-header
            [icon]="['MENUES', 'PAGE_FIX'] | monIcons"
            [header]="'PageCorrect list of fixes' | translate"
            [subHeader]="''">
            <page-header-content>
                <div class="row" *ngIf="showCustomPageFix">
                    <div class="col-48 text-right">
                        <button class="btn btn-border-radius btn-secondary text-bold"
                                (click)="openCustom()" translate>
                            Use or Apply custom PageCorrect
                        </button>
                    </div>
                </div>
            </page-header-content>
        </page-header>
        <mon-tabs
            [maxOptionsDisplay]="6"
            [options]="tabs"
            [(status)]="activeTab"
            (onStatus)="onTabChange($event)"
            [showSearch]="true"
            [search]="search"
            (onSearch)="onSearch($event)"
            [showFiltersBtn]="false">
            <div class="row">
                <div class="col-48 text-right">
                    <button class="btn btn-border-radius btn-secondary text-bold delete-all-btn-padding mr-1"
                            [disabled]="!(autofixes.length > 0) || !(['customer_admin'] | role)"
                            (click)="deleteAll()" translate>
                        Delete All
                    </button>
                </div>
            </div>
        </mon-tabs>
        <div class="card panel-monsido-card">
            <div class="card-body">
                <table-container
                    [noResultMessage]="'No corrections added to PageCorrect' | translate"
                    [collection]="autofixes"
                    (onPageChange)="onPageChange($event)"
                    (onPerPageChange)="onPageSizeChange($event)"
                    [progress]="progress"
                    class="pages-table-wrapper">
                    <table class="table table-hover table-fixed">
                        <thead>
                            <tr>
                                <th class="col-12 col-md-12" translate>
                                    Issue
                                </th>
                                <th class="col-20 col-md-18" translate>
                                    Changed to
                                </th>
                                <th class="col-4 col-md-6 text-right"
                                    monTableSort
                                    [monSortBy]="'updated_at'"
                                    [monSortDirection]="currentSort.direction"
                                    [monCurrentlySortedBy]="currentSort.by"
                                    (monOnSorted)="onMonTableSort($event)">
                                    {{ 'Updated at' | translate }}
                                </th>
                                <th class="col-4 col-md-6 text-right"
                                    monTableSort
                                    [monSortBy]="'created_at'"
                                    [monSortDirection]="currentSort.direction"
                                    [monCurrentlySortedBy]="currentSort.by"
                                    (monOnSorted)="onMonTableSort($event)">
                                    {{ 'Created at' | translate }}
                                </th>
                                <th class="col-8 col-md-6 text-right" translate>
                                    Actions
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let autofix of autofixes">
                                <td class="text-v-middle">
                                    <div *ngIf="autofix.fixable_type === 'SpellingError'"
                                         class="d-flex text-ellipsis">
                                        <icon-circle
                                            [icon]="['SIDEMENUES', 'QA', 'MISSPELLINGS'] | monIcons"
                                            [color]="'text-link'"
                                            aria-hidden="true"
                                            class="mt-1 pl-1 pr-3">
                                        </icon-circle>
                                        <div>
                                            <span translate>Misspelling</span>
                                            <div class="mt-2"
                                                 *ngFor="let error of getErrors(autofix)">
                                                <span class="label label-danger">
                                                    {{error}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="autofix.fixable_type === 'AccessibilitySourceCode' ||
                                               autofix.fixable_type === 'AccessibilityCheck'"
                                         class="d-flex text-ellipsis">
                                        <icon-circle
                                            [icon]="['MENUES', 'ACCESSIBILITY'] | monIcons"
                                            [color]="'text-link'"
                                            aria-hidden="true"
                                            class="mt-1 pl-1 pr-3">
                                        </icon-circle>
                                        <div>
                                            <span translate>Accessibility Snippet</span>
                                            <div class="mt-2"
                                                 *ngFor="let error of getErrors(autofix); trackBy: trackByIndex">
                                                <span class="label label-danger">
                                                    {{error}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="autofix.fixable_type === 'Link' && autofix.change.attribute === 'href'"
                                         class="d-flex text-ellipsis">
                                        <icon-circle
                                            [icon]="['SIDEMENUES', 'QA', 'BROKEN_LINKS'] | monIcons"
                                            [color]="'text-link'"
                                            aria-hidden="true"
                                            class="mt-1 pl-1 pr-3">
                                        </icon-circle>
                                        <div>
                                            <span translate>Broken link</span>
                                            <div class="mt-2"
                                                 *ngFor="let error of getErrors(autofix); trackBy: trackByIndex">
                                                <span class="label label-danger">
                                                    {{error}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="autofix.fixable_type === 'Link' && autofix.change.attribute === 'src'"
                                         class="d-flex text-ellipsis">
                                        <icon-circle
                                            [icon]="['SIDEMENUES', 'QA', 'BROKEN_IMAGES'] | monIcons"
                                            [color]="'text-link'"
                                            aria-hidden="true"
                                            class="mt-1 pl-1 pr-3">
                                        </icon-circle>
                                        <div>
                                            <span translate>Broken Image</span>
                                            <div class="mt-2"
                                                 *ngFor="let error of getErrors(autofix); trackBy: trackByIndex">
                                                <span class="label label-danger">
                                                    {{error}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="autofix.fixable_type === 'custom'" class="d-flex text-ellipsis">
                                        <icon-circle
                                            [icon]="['PAGE_FIX', 'CUSTOM'] | monIcons"
                                            [color]="'text-link'"
                                            aria-hidden="true"
                                            class="mt-1 pl-1 pr-3">
                                        </icon-circle>
                                        <div>
                                            <span translate>Custom rule</span>
                                            <div class="mt-2"
                                                 *ngFor="let error of getErrors(autofix); trackBy: trackByIndex">
                                                <span class="label label-danger">
                                                    {{error}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td class="text-v-middle text-ellipsis">
                                    <page-fix-changeset-spelling
                                        *ngIf="autofix.fixable_type === 'SpellingError'"
                                        [data]="autofix">
                                    </page-fix-changeset-spelling>
                                    <page-fix-changeset-accessibility
                                        *ngIf="autofix.fixable_type === 'AccessibilitySourceCode' ||
                                               autofix.fixable_type === 'AccessibilityCheck'"
                                        [data]="autofix">
                                    </page-fix-changeset-accessibility>
                                    <page-fix-changeset-link
                                        *ngIf="autofix.fixable_type === 'Link'"
                                        [data]="autofix">
                                    </page-fix-changeset-link>
                                    <page-fix-changeset-custom
                                        *ngIf="autofix.fixable_type === 'custom'"
                                        [data]="autofix">
                                    </page-fix-changeset-custom>
                                </td>
                                <td class="text-right text-v-middle">
                                    {{ autofix.updated_at | userDate:'ll' }}
                                </td>
                                <td class="text-right text-v-middle">
                                    {{ autofix.created_at | userDate:'ll' }}
                                </td>
                                <td class="d-flex flex-wrap align-items-center justify-content-end">
                                    <mon-action-menu [monActionMenuItems]="autofix.dropdown" class="mt-1">
                                        <span translate>Action</span>
                                    </mon-action-menu>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </table-container>
            </div>
        </div>
    `,
})
export class PageFixListComponent extends BaseContainerComponentController implements OnInit {
    autofixes: any = [];
    tabs: any;
    showCustomPageFix: boolean = false;
    progress: any;

    constructor (
        private pageFixRepoService: PageFixRepoService,
        private paramService: ParamService,
        private translateService: TranslateService,
        private pageFixService: PageFixService,
        private pageFixListService: PageFixListService,
        private activeFeatureService: ActiveFeatureService,
        private stateService: StateService,
    ) {
        super({ table: true, pages: true });
    }

    ngOnInit (): void {
        this.currentSort = { by: 'created_at', direction: 'desc' };
        this.showCustomPageFix = this.activeFeatureService.isFeatureActive('page_fix_qa_custom');
        this.tabs = [
            {
                name: this.translateService.getString('All'),
                faIcon: this.pipeService.get('monIcons')(['MENUES', 'PAGE_FIX']),
                value: null,
                show: true,
            },
            {
                name: this.translateService.getString('Spelling'),
                faIcon: this.pipeService.get('monIcons')(['SIDEMENUES', 'QA', 'MISSPELLINGS']),
                value: PAGE_FIX_FIXABLE_TYPES.misspelling,
                show: this.activeFeatureService.isFeatureActive('page_fix_qa_misspelling'),
            },
            {
                name: this.translateService.getString('Accessibility Source Code'),
                faIcon: this.pipeService.get('monIcons')(['MENUES', 'ACCESSIBILITY']),
                value: PAGE_FIX_FIXABLE_TYPES.accessibility_source_code,
                show: this.activeFeatureService.isFeatureActive('page_fix_accessibility_source_code'),
            },
            {
                name: this.translateService.getString('Accessibility Check'),
                faIcon: this.pipeService.get('monIcons')(['MENUES', 'ACCESSIBILITY']),
                value: PAGE_FIX_FIXABLE_TYPES.accessibility_check,
                show: this.activeFeatureService.isFeatureActive('page_fix_accessibility_check'),
            },
            {
                name: this.translateService.getString('Links'),
                faIcon: this.pipeService.get('monIcons')(['SIDEMENUES', 'QA', 'BROKEN_LINKS']),
                value: PAGE_FIX_FIXABLE_TYPES.link,
                show: this.activeFeatureService.isFeatureActive('page_fix_qa_links'),
            },
            {
                name: this.translateService.getString('Custom'),
                faIcon: this.pipeService.get('monIcons')(['PAGE_FIX', 'CUSTOM']),
                value: 'custom',
                show: this.activeFeatureService.isFeatureActive('page_fix_qa_custom'),
            },
        ].filter((tab: any) => {
            return tab.show;
        });
        this.autofixes = [];
        this.getPage = this.loadData;
        this.loadLocations();
    }

    loadLocations (): void {
        this.activeTab = this.stateService.params.tab || null;
        this.search = this.stateService.params.search || null;
        this.loadData();
    }

    loadData (): void {
        this.paramService.setParams({
            page: this.page,
            page_size: this.pageSize,
            tab: this.activeTab,
            search: this.search,
        });
        this.getPages();
    }

    getPages (): void {
        const params: any = {
            page: this.page,
            page_size: this.pageSize,
            sort_by: this.currentSort.by,
            sort_dir: this.currentSort.direction,
            search: this.search,
        };

        if (this.activeTab) {
            params.fixable_type = this.activeTab;
        }

        this.progress = this.pageFixRepoService.getAll(params).then((data: any) => {
            this.autofixes = data;
            this.updateDropdowns();
        }, () => {});
    }

    updateDropdowns (): void {
        for (const autofix of this.autofixes) {
            const dropdown = [
                {
                    label: this.translateService.getString('Update'),
                    leftIcon: 'faCog',
                    action: () => this.updateShield(autofix),
                },
                {
                    label: this.translateService.getString('Remove'),
                    leftIcon: 'faTrashAlt',
                    action: () => this.removeShield(autofix),
                },
            ];

            autofix.dropdown = dropdown;
        }
    }

    updateShield (autofix: any): void {
        if (!autofix.fixable_id && autofix.fixable_type === 'custom') {
            this.openCustom(autofix);
            return;
        }
        const model = {
            id: autofix.change.check_id || autofix.fixable_id,
        };

        this.pageFixService.update(autofix.normalizeFixableType(), model, autofix.change.attribute, autofix,
            (result: any) => {
                if (result !== undefined) {
                    this.getPages();
                }
            });
    }

    removeShield (autofix: any): void {
        this.pageFixService.remove(autofix).then((result: any) => {
            if (result !== undefined) {
                this.getPages();
            }
        }, () => {});
    }

    getErrors (pageFix: any): any {
        return this.pageFixListService.getError(pageFix);
    }

    openCustom (pageFix?: any): void {
        this.pageFixService.openCustom(pageFix, (model: any) => {
            if (model !== undefined) {
                this.getPages();
            }
        });
    }

    deleteAll (): void {
        const params = {
            fixable_type: this.activeTab || 'all',
        };
        this.pageFixService.removeAll(params).then((result: any) => {
            if (result !== undefined) {
                this.getPages();
            }
        }, () => {});
    }

    trackByIndex (index: number): number {
        return index;
    }
}
